<template>
	<div class="ReMessengersTemplate">
		<div class="textareaTemplate">           
			<textarea 
			class="form-control"
			:placeholder="templateObj.text"
			v-model="textmessage" 
			@focus="emptyCheckboxes()"
			>	
			</textarea>	
		</div>

		<div class="messangers mt-2 d-flex">
			<div class="d-flex mb-2 mb-3 align-items-center">
				<base-button   
				@click="copyTxtForEdit()" 
				class="btn-simple btn-success my-0 mr-2" 
				>Заполнить шаблон</base-button>	
			 </div>
			<div class="d-flex mb-2 mb-3 align-items-center">
				<h5 class="col-form-label mr-3 py-0">Куда отправить</h5>
				<el-checkbox-group v-model="masMessengers">
					<div class="aaa">
						
						<el-checkbox v-for="item in this.messengers" :label="item.type" :key="item.type" @change="getMessengerTypes()">
							<div class="d-flex align-items-center" >
								<i class="d-inline-flex messicon messicon-whatsapp" v-if="item.type=='whatsapp'"></i> 
								<!-- <i class="d-inline-flex messicon messicon-telegram" v-if="item.type=='telegram'"></i> 
								<i class="d-inline-flex messicon messicon-viber" v-if="item.type=='viber'"></i>  -->
								<span class="">{{item.type}}</span> 
							</div> 
						</el-checkbox>
					</div>
				</el-checkbox-group>
				
			</div>
			
		</div>
		<!-- <div class="mb-3">Такое value полетит на бэкэнд {{ value }}</div> -->
		<!-- <div>v-model="textmessage"   {{ textmessage }}</div> -->
	</div>
</template>


<script>
	// import { BaseCheckbox } from 'src/components/index';
	import { CheckboxGroup, Checkbox, Button } from 'element-ui';
	
	

	export default {
		name: 'ReMessengersTemplate',
		components: {
			// BaseCheckbox,
			[Checkbox.name]: Checkbox, 
			[CheckboxGroup.name]: CheckboxGroup,
			[Button.name]: Button,
			
		},
		props: {
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			// value: {
			// 	type: Object,
			// 	default() {	return {
			// 		text: '',
			// 		messengerTypes:''
			// 	}; }
			// },
			value: {
                type: String,
                default(){return '{}';},
            },
			externalParamsValue:{
                type: Object,
                default(){ return {}; },
            },
		},
		data () {
			return {
				ver: 1,

				messengers: [
					// {type: 'telegram', value:false, elementType: 'checkbox', value_default: false},
					{type: 'whatsapp', value:false, elementType: 'checkbox', value_default: false},
					// {type: 'viber', value:false, elementType: 'checkbox', value_default: false},
				],
				//bufferValue: [],
				bufferValue: {text: '', messengerTypes:'',},
				templateObj: {text: '', messengerTypes:'', agent_phone: ''},
				client_name: '',
				client_patronymic: '',
				agent_name: {inputText:'', selectedVal:''},
				agent_contact: '',
				objects: [],
				masMessengers: [],
				textmessage: '',
			}
		},
		computed: {
			
			textT: function(){
				// текстовый шаблон
				let text = '';
				let textBody = '';
				let textHeader = '';
				let textFooter = ''; //'\n\nДанное сообщение сформировано автоматически, пожалуйста, не отвечайте на него.';

				if(this.client_name !='' && this.client_patronymic ==''){textHeader = `Здравствуйте, ${this.client_name}!\n`;}
				if(this.client_name !='' && this.client_patronymic !='' ){textHeader = `Здравствуйте, ${this.client_name} ${this.client_patronymic}!\n`;}

				if(this.objects.length == 0 && this.agent_name.inputText !='') {
					textBody = `Спасибо, что обратились в компанию Александр-Недвижимость. Ваш специалист ${this.agent_name.inputText}, номер для связи ${this.templateObj.agent_phone}.`;
					// textBody = this.objects.join('\n');
					// console.log("this.bufferValue", this.bufferValue);
				} else if (this.objects.length == 1){
					textBody = this.objects.join('\n');
				} else if (this.objects.length > 1) {
					textBody = 'Вы интересовались объектами:\n' + this.objects.join('\n');
				}
				// this.bufferValue = textHeader + textBody;
				text = textHeader + textBody + textFooter;
				this.templateObj.text = text;
				// this.textmessage = text;

				// return this.templateObj;
				return this.templateObj.text;
			},
		},
		watch:{
			value(val){
				// this.bufferValue = this.$GVO.unlinkObject(val);
				// this.bufferValue  = val ;
				this.pFillBuffer();
				// console.log('value',val);
			},
			bufferValue:{
				deep:true,
				handler(val){
					
					//console.log('bufferValue',val );
					this.bufferValue  = val ;
					// this.bufferValue = {text: this.textmessage, messengerTypes: this.templateObj.text,}
					// this.textT;
					this.$emit("input", JSON.stringify(this.bufferValue));
				}
			},
			externalParamsValue:{
				// магия получения параметров из других компонентов формпринтера
                handler(value){
                    this.prepareData();
					// this.textT;
					// console.log('externalParamsValue',value);
                },
                deep: true,
            },
			templateObj:{
				// без этого вотчера не пишется телефон выбранного агента в сообщение 
				deep:true,
				handler(val){
					this.templateObj  = val ;
					this.textT;
					// this.$emit("input", this.templateObj);
				}
			},
			// textmessage(val){
			// 	// this.bufferValue = this.$GVO.unlinkObject(val);
			// 	this.textmessage  = val;
			// 	// this.bufferValue.text = this.textmessage;
			// 	console.log('textmessage',val);
			// },
		},
		methods: {
			pFillBuffer(){
                try{
				    //this.bufferValue = this.$GVO.unlinkObject(val);
                    this.bufferValue = JSON.parse(this.value||'{}');
					
                }catch(e){
                    this.bufferValue = {};
                }
            },
			getMessengerTypes(){
				let messengerTypes = '';
				if(this.masMessengers.length > 0){
					// this.textmessage = this.templateObj.text;
					messengerTypes = this.masMessengers.join();
				
				} else {this.bufferValue.messengerTypes = '';}
				
				//при клике на чекбокс копируем финальное сообщение в буфферное валуе
				if(messengerTypes!='' && this.textmessage!='' ){
					// this.copyTxtForEdit();
					// this.textmessage = this.templateObj.text;
					this.finalDataBoss(this.textmessage, messengerTypes, );
					
					// this.textmessage = this.templateObj.text;
				}
			},
			finalDataBoss(text, messengerTypes){
				
				this.bufferValue.text = text;
				this.bufferValue.messengerTypes = messengerTypes;
					
				//return this.bufferValue;
			},
			emptyCheckboxes(){
				this.masMessengers = [];	
				this.bufferValue.messengerTypes = '';
			},
			copyTxtForEdit(){
				// эта фиговина скопирует шаблон в переменную и даст редактировать собщение дальше (текстария для v-model)
				this.masMessengers = [];
				this.textmessage = this.templateObj.text;
				// сonsole.log('copyTxtForEdit', textmessage);
			},
			prepareData(){ 
				// магия получения параметры из других компонентов формпринтера + запись части данных в текстовый шаблон.
				this.objects = [];
				if(!this.externalParamsValue) return;
				if(this.externalParamsValue.AUTO_DISPATCH_CONTAINERFIELD_fio_padej){
					try{
                        this.client_name = this.externalParamsValue.AUTO_DISPATCH_CONTAINERFIELD_fio_padej.name;
                        this.client_patronymic = this.externalParamsValue.AUTO_DISPATCH_CONTAINERFIELD_fio_padej.patronymic;
                    }catch(e){}
				}
				if(this.externalParamsValue.objects_json){
					try{
						// let objects = JSON.parse(this.externalParamsValue.objects_json);
						let parsedObjects = JSON.parse(this.externalParamsValue.objects_json);
						// this.objects = JSON.parse(this.externalParamsValue.objects_json);
						let addr = '';
						let objects = [];
						if(parsedObjects.length == 1){
							if(parsedObjects[0].MapAddress && parsedObjects[0].MapAddress.address.inputText!=''){addr = parsedObjects[0].MapAddress.address.inputText}else{addr = parsedObjects[0].address}
							objects.push(`Вы интересовались объектом ${parsedObjects[0].id} по адресу ${addr}. Цена объекта: ${this.$GVO.number_format(parsedObjects[0].price,0,'.',' ')} ₽. Ваш специалист ${parsedObjects[0].service_agent_fio}, номер для связи ${parsedObjects[0].staff_info_mobile_phone}. `);
						} else {
							parsedObjects.forEach(object => {
								if(object.MapAddress && object.MapAddress.address.inputText!=''){addr = object.MapAddress.address.inputText}else{addr = object.address}
								objects.push(`- ${object.id} по адресу ${addr}.  Цена объекта: ${this.$GVO.number_format(object.price,0,'.',' ')} ₽. Специалист ${object.service_agent_fio}, номер для связи ${object.staff_info_mobile_phone}; `);
							});
						}
						this.objects = objects;
						// console.log(this.objects);
						this.textT;
					}catch(e){
						console.error('ReMessangerTemplat',e)
					}
				}
				if(this.externalParamsValue.agent_id){
					
					try{
						this.agent_name.inputText = this.externalParamsValue.agent_id.inputText;
						this.agent_name.selectedVal = this.externalParamsValue.agent_id.selectedVal;
						if(this.agent_name.selectedVal !=''){this.getAgentContacts();}
						this.textT;
					}catch(e){
						// this.agent_name.inputText = ;
					}
				}
				
			},
			getAgentContacts(){
				
				if(this.agent_name.selectedVal > ''){
					
					this.$GVO.ApiCall('staff.GET_MAIN_CONTACTS',{flt:{code:this.agent_name.selectedVal }},{useCache:true})
					.then((objApi) => {
						if(objApi.success === true){ 
							this.templateObj.agent_phone = objApi.data[0].MobilePhone;
							this.agent_contact = objApi.data[0].MobilePhone;
							//console.log('getAgentContacts',this.bufferValue.agent_phone);
						}else{
							this.templateObj.agent_phone = '';
							this.agent_contact = '';
						} 
					}).catch(errorObjApi => {/*this.bufferValue.agent_phone = ''; */console.error(errorObjApi); });
					//return	this.bufferValue;
				}
			},
			
		},
		mounted() {
			this.prepareData();
			//this.pFillBuffer();
			
			// this.getAgentContacts();
			
		},
	}
</script>
<style scoped>
	.ReMessengersTemplate >>> .messicon {
		width: 18px;
		height: 18px;
		margin-right: 3px;
		/* display: inline-block;
		margin-top: 8px; */
	}
	.ReMessengersTemplate >>> .messicon-telegram {background: url('/img/icons/telegramlogo.svg') no-repeat; }
	.ReMessengersTemplate >>> .messicon-whatsapp {background: url('/img/icons/whatsapplogo.svg') no-repeat; }
	.ReMessengersTemplate >>> .messicon-viber {background: url('/img/icons/viberlogo.svg') no-repeat; }
	.ReMessengersTemplate >>> .messicon-skype {background: url('/img/icons/skypelogo.svg') no-repeat; }
	.template-text {border: 1px solid #01B0E0; border-radius: 0.2857rem;white-space: pre-wrap;}
	.ReMessengersTemplate >>> .el-checkbox__label{font-size: 12px;}
	.ReMessengersTemplate >>> .el-checkbox__inner {width: 17px; height: 17px; border: 1px solid #6679b0; border-radius: 3px;}
	.ReMessengersTemplate >>> .el-checkbox__inner::after {left:6px; top:2px;}
	.ReMessengersTemplate >>> .el-checkbox {display: inline-flex; align-items: center; margin-bottom: 0;}
	.ReMessengersTemplate >>> .el-checkbox__input.is-checked+.el-checkbox__label {color: inherit;}
	.ReMessengersTemplate >>> .textareaTemplate .form-control {color:#01B0E0;}
</style>
